import { makeAutoObservable } from 'mobx';
import Annotation from './Annotation';
import Survey from './Survey';
import { ANALYSE_TIME_RANGE } from '../../../../constants';
import guid from '../../../../utils/guid';
import { sort, SORT_DATA_TYPES } from '../../../../utils/array';

export default class Analyse {
  id;
  date_created;
  buildingBlocks = [];
  annotations = [];
  surveys = [];
  finished = false;
  timeRange;

  constructor({
    id = guid(),
    date_created = new Date(),
    buildingBlocks = [],
    annotations = [],
    surveys = [],
    finished = false,
    timeRange = ANALYSE_TIME_RANGE
  }) {
    this.id = id;
    this.date_created = date_created;
    this.buildingBlocks = buildingBlocks;
    this.finished = finished;
    this.timeRange = timeRange;

    this.annotations =
      annotations && annotations.length
        ? annotations.map(t => new Annotation(t))
        : [];

    this.surveys =
      surveys && surveys.length ? surveys.map(t => new Survey(t)) : [];

    this.surveys = sort(this.surveys, {
      keys: [
        { key: 'buildingBlockId', dataType: SORT_DATA_TYPES.NUMBER },
        { key: 'last', dataType: SORT_DATA_TYPES.BOOL }
      ]
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }

  get isReadMode() {
    return this.finished === true;
  }

  getSurveysByIndex(index) {
    return this.surveys.filter(s => s.index === index);
  }

  static getLastSurvey(surveys) {
    return surveys.filter(s => s.last === true);
  }

  getSapId(email, index, buildingBlockId) {
    return `${email},${this.id},${buildingBlockId},${index}`;
  }

  getSurvey(buildingBlockId, index, last) {
    return this.surveys.find(
      s =>
        s.buildingBlockId === buildingBlockId &&
        s.index === index &&
        s.last === last
    );
  }

  getSurveyToShow(email, index, last, nextSurvey) {
    // Loop over unfinished surveys
    let survey;
    for (let bb of this.buildingBlocks) {
      const finishedSurvey = this.getSurvey(bb, index, false);
      const sapId = this.getSapId(email, index, bb);
      if (!finishedSurvey) {
        survey = Survey.createLocal(sapId, bb, index);
        break;
      }

      if (last) {
        const finishedLastSurvey = this.getSurvey(bb, index, true);
        if (!finishedLastSurvey) {
          survey = Survey.createLocal(sapId, bb, index, true);
          break;
        }
      }
    }

    // returns a new survey
    if (survey) return survey;

    const surveys = this.getSurveysByIndex(index);
    surveys.sort((a, b) => {
      return a.buildingBlockId - b.buildingBlockId || a.last - b.last;
    });

    // All surveys are filled
    // when nextSurvey is defined return next survey
    if (nextSurvey) {
      let currentListIndex = surveys.findIndex(s => s.id === nextSurvey.id);
      const sur = surveys[++currentListIndex];
      if (sur) return sur;
    }
    return surveys[0];
  }

  get hasFinishedAllSurveys() {
    const finishedSurveys = this.surveys.filter(
      survey => survey.finished === true
    );
    if (finishedSurveys.length === this.buildingBlocks.length) {
      return true;
    }
    return false;
  }
}
